<template>
  <div class="info-box-details">
    <div class="info-box-details-caption">Number of application<br/>versions installed</div>
    <div class="info-box-details-table">
      <table class="table table-borderless">
        <tbody>
          <tr repeat.for="installedVersions of model">
            <td style="text-align: left;">${ installedVersions.version.major }.${ installedVersions.version.minor }.${ installedVersions.version.patch }</td>
            <td style="text-align: right;">${ installedVersions.count }</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
